export const closeModal = () => {
  return {
    type: 'closeModal'
  }
}

export const openModal = (data) => {
  return {
    type: 'openModal',
    payload: data
  }
}

export const showModalMessage = (data) => {
  return {
    type: 'showModalMessage',
    payload: data
  }
}

export const dismissModalMessage = () => {
  return {
    type: 'dismissModalMessage'
  }
}

export const toggleOffCanvas = (direction) => {
  return {
    type: 'toggleOffCanvas',
    payload: direction
  }
}

export const togglePanel = (panelId) => {
  return {
    type: 'togglePanel',
    payload: panelId
  }
}



// WEBPACK FOOTER //
// ./common/actions/layout.js